module.exports = __webpack_public_path__ + "static/media/jan 2021.87b5384c.svg";